import { simpleCampaignsQueryOptions } from "@/api/campaign.api";
import { IntroView } from "@/components/layout/IntroView";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/start")({
  component: RouteComponent,
  beforeLoad: async ({ context }) => {
    const campaigns = await context.queryClient.ensureQueryData(
      simpleCampaignsQueryOptions,
    );

    if (campaigns && campaigns.length > 0) {
      throw redirect({
        to: "/",
        replace: true,
      });
    }
  },
});

function RouteComponent() {
  return <IntroView title="Kampagner" />;
}
